import csCZ from 'antd/locale/cs_CZ.js';
import deDE from 'antd/locale/de_DE.js';
import enUS from 'antd/locale/en_US.js';
import esES from 'antd/locale/es_ES.js';
import frFR from 'antd/locale/fr_FR.js';
import itIT from 'antd/locale/it_IT.js';
import nlBE from 'antd/locale/nl_BE.js';
import plPL from 'antd/locale/pl_PL.js';
import ptPT from 'antd/locale/pt_PT.js';
import { Language } from '@data/utils/enums';

export const antdLocales = {
  [Language.EN]: enUS,
  [Language.NL]: nlBE,
  [Language.FR]: frFR,
  [Language.DE]: deDE,
  [Language.CS]: csCZ,
  [Language.ES]: esES,
  [Language.IT]: itIT,
  [Language.PT]: ptPT,
  [Language.PL]: plPL,
};
